import qs from "query-string";

import BaseRepository from "../../../lib/itn-ui-kit/services/repositories/base-repository";
import CaseNotesModel from "../../models/case-notes";

const getListPath = (entityId, params = {}) =>
  `entities/${entityId}/notes/?${qs.stringify(params)}`;
const getCreatePath = (entityId) => `entities/${entityId}/add_note/`;
const getDeletePath = (entityId, noteId) => `entities/${entityId}/delete_note/${noteId}/`;
const getUpdatePath = (entityId, noteId) => `entities/${entityId}/update_note/${noteId}/`;

export default class EntityNotesRepository extends BaseRepository {
  static modelClass = CaseNotesModel;
  modelName = "case-notes";

  async query(params = {}) {
    const { entityId, ...queryParams } = params;
    return await super.query({ urlPath: getListPath(entityId, queryParams) });
  }

  async createRecord(entityId, data) {
    return await super.createRecord(data, {
      urlPathWithQueryParams: getCreatePath(entityId),
    });
  }

  async patch(noteId, data, entityId) {
    return await super.patch("", data, {
      urlPath: getUpdatePath(entityId, noteId),
    });
  }

  async delete(noteId, entityId) {
    return await super.delete("", {
      urlPath: getDeletePath(entityId, noteId),
    });
  }
}
